<div class="max-w-2xl mx-auto p-6">
  <h1 class="text-2xl font-semibold mb-2 text-surface-900 dark:text-surface-0">Two-factor authentication</h1>
  <p class="text-surface-500 mb-6">Add a second factor to your account so a leaked password isn't enough to sign in.</p>

  <p-card>
    @if (loading()) {
      <div class="flex justify-center p-8">
        <p-progress-spinner></p-progress-spinner>
      </div>
    } @else if (errorLoading()) {
      <p class="text-center text-red-600">Could not load MFA status. Try refreshing the page.</p>
    } @else if (enabled()) {
      <zaeper-two-factor-manage
        (disabled)="onDisabled()"
      ></zaeper-two-factor-manage>
    } @else {
      <zaeper-two-factor-setup
        (setupComplete)="onSetupComplete()"
      ></zaeper-two-factor-setup>
    }
  </p-card>
</div>
